import _extends from "../../../@babel/runtime/helpers/esm/extends.es.js";
import generateUtilityClasses from "../../utils/generateUtilityClasses/generateUtilityClasses.es.js";
import inputBaseClasses from "../InputBase/inputBaseClasses.es.js";
import generateUtilityClass from "../../utils/generateUtilityClass/generateUtilityClass.es.js";
function getFilledInputUtilityClass(slot) {
  return generateUtilityClass("MuiFilledInput", slot);
}
const filledInputClasses = _extends({}, inputBaseClasses, generateUtilityClasses("MuiFilledInput", ["root", "underline", "input"]));
const filledInputClasses$1 = filledInputClasses;
export {
  filledInputClasses$1 as default,
  getFilledInputUtilityClass
};
//# sourceMappingURL=filledInputClasses.es.js.map
